<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';

const isVisible = ref(false);
const isElementAdded = ref(false);

const addScrollUpButton = () => {
  if (!isElementAdded.value) {
    isElementAdded.value = true;
  }
};

const handleScroll = () => {
  const singlePage = document.getElementsByClassName("main_product");
  isVisible.value = window.scrollY > 300 && singlePage.length === 0;
};

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

onMounted(() => {
  document.addEventListener("mousemove", addScrollUpButton, { once: true });
  document.addEventListener("touchstart", addScrollUpButton, { once: true });
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<template>
  <button v-if="isElementAdded" id="scrollUpButton" :style="{ display: isVisible ? 'block' : 'none' }"
    @click="scrollToTop">

    <img src="/arrow2.webp" alt="Back to top" />
  </button>
</template>

<style scoped>
#scrollUpButton {
  position: fixed;
  bottom: 100px;
  right: 33px;
  padding: 10px;
  border: none;
  border-radius: 5px;
  background-color: #FFEEE6;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 5px 6px 0px;
  cursor: pointer;
  z-index: 1000;
}

#scrollUpButton img {
  width: 15px;
  height: 20px;
}

@media (max-width: 767px) {
  #scrollUpButton {
    bottom: 95px;
    right: 35px;
  }

  #scrollUpButton img {
    height: 13.333px;
    width: 10px;
  }
}
</style>
